define('LNRS/Track/TrackBounceRate',["jquery"], function ($) {

    // 7.10.13 Adjusted Bounce Rate Trigger
    return function trackBouncRate(pageId) {
        var def = $.Deferred(), promise = def.promise();

        if (!sessionStorage.getItem("lnrs_session_1st_page")) {
            sessionStorage.setItem("lnrs_session_1st_page", pageId);
            window.setTimeout(def.resolve.bind(def), 15000);
        } else {
            def.reject();
        }

        return promise;
    };
});
